import styled from 'styled-components';

export const Container = styled.div`
    display:block;
    height:100%;
    overflow:auto;
    width:100%;
    min-width:450px;
    background-color:#EDEFF5;

    /* width */
    ::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius:0px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .endereco {
        display:flex;
        align-items:center;
        background-color:0;
        width:88%;
        margin:20px auto;
        img {
            width:20px;
            height:20px;
        }
        .bar {
            font-size:18px;
            color:#bdbdbd;
            margin:0 15px;
        }
        .place {
            color:#175372;
        }
    }
`;
export const Content = styled.body`
    width: 100%;
    margin: 0 auto;
    display: flex;
    margin-top: 10px;
    padding-left: 13vw;
    align-items: center;
    background-color:0;

    svg {
        margin-left: 16px;
        margin-right: 16px;
        width: 30px;
        height: 30px;
    }
`;
export const Title = styled.div`
    display: flex;
    width:100%;
    background-color:0;
    align-items: center;
    flex-wrap: wrap;

    svg {
    
        margin-right: 10px;
        width: 25px;
        height: 25px;
    }
`;
export const ContentCard = styled.div`
    background-color:0;
    flex-direction: column;
    margin: 0 auto 20px auto;
    background-color:0;
    display: flex;
    align-items: left;
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.15);
    border-radius: 5px;
    padding-left: 0px;
    & + div {
        padding:0 3%;
    }

    label {
        display: flex;
        padding-right: 16px;
    }


`;
export const ContentFormHeader = styled.div`
background-color:0;
margin-top: 16px;
padding-top: 0px;
padding-left: 0px;

flex-direction: column;

display: flex;
align-items: left;

border-radius: 2px;

`;
export const FormContent = styled.div`
display: flex;
width:100%;
align-items: center;
flex-wrap: wrap;
border-radius: 2px;
background-color:0;
`;
export const DescriptionContent = styled.div`
    box-shadow: none;
    cursor: pointer;
    font-size:8pt;
    max-height:30px;
    margin-left:10px;
    overflow:hidden;
    opacity:0.6;
    text-overflow:ellipsis;

    transition:0.25s;
    :hover{
        box-shadow: 0px 0.4px 0px rgba(0, 0, 0, 0.25);
        margin-left:20px;
        opacity:1;
    }
`;